angular.module('env.data.rest.model.modelFactory', [])

    .provider('modelFactory', function () {

        /**
         * Hash of model configs, waiting for initialization
         */
        var modelDefinitionsInitQueue = {};

        /**
         * Create new a model definition
         * @param {string} modelType model type name
         * @param {*} config model definition configuration
         */
        function define(modelType, config) {
            if (modelDefinitionsInitQueue[modelType]) {
                throw new Error(_.str.sprintf("Duplicate model definition: %s", modelType));
            }
            modelDefinitionsInitQueue[modelType] = config;
        }

        _.extend(this, {
            define: define
        });

        this.$get = function ($log, ModelDefinition) {

            function ModelFactory(initQueue) {

                /**
                 * Hash of defined models
                 */
                var modelDefinitions = {};

                constructor();

                /**
                 * Isolated constructor
                 */
                function constructor() {
                    // Helper hash - model type to array of dependencies
                    var dependenciesHash = {};

                    _.forEach(initQueue, function (value, key) {
                        dependenciesHash[key] = getDependencies(value);
                    });

                    var i;
                    // trying to init over and over again until we initialize everything we can
                    do {
                        i = 0;
                        _.forEach(initQueue, function (value, key) {
                            if (checkDependenciesAreInitialized(key)) {
                                initializeModelDefinition(key, value);
                                i++;
                            }
                        });
                    } while (i != 0);

                    checkConfiguration();

                    /**
                     * Get dependencies array of model definition
                     * @param {*} config model definition configuration
                     * @returns {Array} array of model types names
                     */
                    function getDependencies(config) {
                        var result = [];
                        if (!config.extend) {
                            // hm...
                        } else if (_.isArray(config.extend)) {
                            _.forEach(config.extend, function (el) {
                                if (_.isString(el)) {
                                    result.push(el);
                                }
                            });
                        } else if (_.isString(config.extend)) {
                            result.push(config.extend);
                        }
                        return result;
                    }

                    /**
                     * Check dependencies of model definition are initialized
                     * @param {string} modelType model type
                     * @returns {boolean} true if all dependencies of model definition are initialized
                     */
                    function checkDependenciesAreInitialized(modelType) {
                        return !_.find(dependenciesHash[modelType], function (req) {
                            return !modelDefinitions[req];
                        });
                    }

                    /**
                     * Initialize model definition from config
                     * @param {string} modelType model type
                     * @param {*} config model definition configuration
                     */
                    function initializeModelDefinition(modelType, config) {
                        var definition = new ModelDefinition(modelType, config, modelDefinitions);
                        delete initQueue[modelType];
                        modelDefinitions[modelType] = definition;
                    }

                    /**
                     * Check if some model definitions was not initialized
                     */
                    function checkConfiguration() {
                        var wasErrors = false;
                        _.forEach(initQueue, function (config, modelType) {
                            $log.warn("Can't initialize model definition `%s`. Please check model definition configuration.", modelType);
                            wasErrors = true;
                        });
                        if (wasErrors) {
                            throw new Error("Unable to finish initialization of `modelFactory`. See errors before.");
                        }
                    }
                }

                /**
                 * Get model definition names
                 * @returns {Array} array of declared model types
                 */
                function getDeclaredTypes() {
                    return _.keys(modelDefinitions);
                }

                /**
                 * Get model definition by its name
                 * @param {string} modelType type of the model
                 * @returns {ModelDefinition}
                 */
                function getDefinition(modelType) {
                    return modelDefinitions[modelType];
                }

                _.extend(this, {
                    getDefinition: getDefinition,
                    getDeclaredTypes: getDeclaredTypes
                });
            }

            return new ModelFactory(modelDefinitionsInitQueue);
        }
    })

;